import { render, staticRenderFns } from "./IconTypography.vue?vue&type=template&id=136bb175&"
import script from "./IconTypography.vue?vue&type=script&lang=js&"
export * from "./IconTypography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136bb175')) {
      api.createRecord('136bb175', component.options)
    } else {
      api.reload('136bb175', component.options)
    }
    module.hot.accept("./IconTypography.vue?vue&type=template&id=136bb175&", function () {
      api.rerender('136bb175', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTypography.vue"
export default component.exports